<template>
  <div
    :gs-h="widget.h"
    :gs-id="widget.id"
    :gs-w="widget.w"
    :gs-x="widget.x"
    :gs-y="widget.y"
    class="grid-stack-item ui-draggable ui-resizable ui-resizable-autohide"
  >
    <div
      class="grid-stack-item-content"
      draggable="true"
      v-html="widget.content"
    />
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    widget: {
      type: Object,
      required: true
    }
  },
}
</script>

<style lang="scss" scoped>
.grid-stack-item:hover :deep(> div.dots_menu) {
  visibility: visible;
}

.grid-stack-item :deep(.grid-stack-item-content) {
  border: solid 1px white;
  overflow: hidden !important;

  &:hover {
    border: solid 1px lightgrey;
  }

  .insights-error {
    color: var(--negative-color);
    margin-right: 5px;
  }

  p {
    font-family: inherit;
  }

  ol,
  ul,
  .widget_textarea ol,
  .widget_textarea ul {
    color: #53626b;
    list-style: initial;
    padding: unset;
    padding-inline-start: 40px;
    line-height: 1.9;
  }

  & > ol,
  .widget_textarea ol {
    list-style-type: decimal;
  }

  & > ul,
  .widget_textarea ul {
    list-style-type: disc;
  }

  & > ol > li,
  & > ul > li {
    word-break: break-word;
  }

  .widget_textarea {
    word-break: break-word;
    font-family: inherit;
    margin: 0;
    margin-bottom: 1rem;
  }

  .grid-image {
    max-width: 100%;
    max-height: 100%;
    margin: auto;
    display: block;
  }

  .widget-table-heading {
    width: 100%;
    font-size: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: black;
  }

  .widget-table {
    display: grid;
    border-top: solid 1px lightgrey;
    border-right: solid 1px lightgrey;
    color: black;
  }

  .widget-table span.widget-table-header {
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    border-left: solid 1px lightgrey;
    border-bottom: solid 1px lightgrey;
    overflow: inherit;
  }

  .widget-table > span {
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    padding: 12px 4px;
    border-left: solid 1px lightgrey;
    border-bottom: solid 1px lightgrey;
    overflow: hidden;
    line-height: initial;
  }

  .widget-table > span.green {
    color: white;
    background-color: #6cc58c;
    font-weight: 700;
  }

  .widget-table > span.amber {
    background-color: #fdeb75;
    font-weight: 700;
  }

  .widget-table > span.red {
    color: white;
    background-color: #d47777;
    font-weight: 700;
  }

  .widget-table > span.high {
    color: #fa625a;
    font-weight: 700;
  }

  .widget-table > span.medium {
    color: #ffbb00;
    font-weight: 700;
  }

  .widget-table > span.low {
    color: #8fc83f;
    font-weight: 700;
  }

  .widget-table > span.positive {
    color: #37B2A8;
  }

  .widget-table > span.negative {
    color: #F34F4F;
  }

  .elipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .widget-statbox-heading {
    width: 100%;
    font-size: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: black;
  }

  .statbox_wrapper {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-evenly;
  }

  .statbox {
    height: 117px;
    max-width: 210px;
    width: 100%;
    background-color: white;
    padding: 1rem;
    border-radius: .75rem;
    border: solid 1px lightgray;
  }

  .stabox_heading {
    display: flex;
    align-items: center;
    margin-bottom: .5rem;
  }

  .statbox_title {
    margin-right: auto;
    font-weight: 500;
    font-size: 1.5rem;
    line-height: 1.25;
    letter-spacing: -0.042em;
    color: #040707;
  }

  .statbox_source {
    text-align: right;
    font-size: .5rem;
    line-height: 1.3;
    letter-spacing: -0.015em;
    color: #909096;
  }

  .statbox_body {
    position: relative;
    display: inline-block;
    font-size: .875rem;
    line-height: 1.625;
    letter-spacing: -0.015625em;
    color: #4E4E54;
  }

  .statbox_detail {
    font-size: 0.75rem;
    line-height: 1.3;
    letter-spacing: -0.1px;
    color: #909096;
    margin-top: 1.5rem;
  }

  .statbox_diff {
    margin-top: 5px;
  }

  .statbox_title.positive,
  .statbox_diff.positive {
    color: #37B2A8;
  }

  .statbox_title.negative,
  .statbox_diff.negative {
    color: #F34F4F;
  }

  .error_message {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-size: 10pt;
    border: solid 1px red;
  }

  .error_message > p:nth-of-type(1) {
    font-size: 12pt;
  }

  .error_message > a {
    color: blue;
    margin-bottom: 5px;
  }

  .progress {
    width: 70%;
    margin-top: 5px;
    margin-bottom: 0;
  }

  .progress-bar {
    background-color: #00c6dd;
  }
}
</style>
